import { useState } from "react";
import {
  Box,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Snackbar,
  Alert,
  // Button, // 开通会员按钮已隐藏，暂时用不到
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import ChatIcon from "@mui/icons-material/Chat";
import EmailIcon from "@mui/icons-material/Email";
// import WechatIcon from "@mui/icons-material/ChatBubble"; // 作者微信联系方式已移除
import PageHeader from "./PageHeader";
// import dayjs from "dayjs"; // 会员到期时间展示已隐藏，暂时用不到

// TODO: 替换为实际的联系方式
const CONTACT_INFO = {
  qqGroup: "1070376554", // QQ交流群号
  // wechat: "ahaofan_cn", // 作者微信号（联系方式已按要求移除）
  email: "252468400@qq.com", // 作者邮箱
};

// function isMember(user) {
//   if (!user) return false;
//   if (user.is_member !== undefined) return user.is_member;
//   if (user.member_type === 0) return false;
//   if (user.member_expires_at) {
//     return new Date(user.member_expires_at) > new Date();
//   }
//   return true;
// }

export default function MyPage({ user, onLoginClick, onLogout /*, onMemberClick */ }) {
  const [copyTip, setCopyTip] = useState({ open: false, message: "" });

  async function handleCopy(text, label) {
    try {
      await navigator.clipboard.writeText(text);
      setCopyTip({ open: true, message: `${label}已复制成功` });
    } catch (err) {
      // 降级方案：如果浏览器不支持 clipboard API，尝试 execCommand
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(input);
      if (ok) {
        setCopyTip({ open: true, message: `${label}已复制成功` });
      } else {
        setCopyTip({ open: true, message: "复制失败，请手动复制" });
      }
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <PageHeader title="我的" />
      {/* 用户信息卡片 */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 2,
          mb: 2,
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        <Avatar sx={{ width: 56, height: 56, bgcolor: "primary.main" }}>
          {user ? user.username.charAt(0).toUpperCase() : <PersonIcon />}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {user ? (
            <>
              <Typography variant="h6" noWrap>
                {user.username}
              </Typography>
              {/* 所有功能已免费开放，会员标识/开通入口隐藏，原代码保留：
              <Box sx={{ mt: 0.5 }}>
                {isMember(user) ? (
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.8,
                      mt: 0.5,
                      px: 1.5,
                      py: 0.35,
                      borderRadius: 9999,
                      bgcolor: "#fef3c7",
                      border: "1px solid #fcd34d",
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      color: "#b45309",
                    }}
                  >
                    <Box component="span">✦ 会员</Box>
                    <Box
                      component="span"
                      sx={{
                        width: 3,
                        height: 3,
                        borderRadius: "50%",
                        bgcolor: "#fbbf24",
                      }}
                    />
                    <Box component="span" sx={{ fontWeight: 500, opacity: 0.85 }}>
                      {user.member_expires_at
                        ? dayjs(user.member_expires_at).format("YYYY-MM-DD") + " 到期"
                        : "永久有效"}
                    </Box>
                  </Box>
                ) : (
                  <Button
                    size="small"
                    onClick={onMemberClick}
                    sx={{
                      textTransform: "none",
                      borderRadius: 9999,
                      px: 2,
                      py: 0.3,
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      color: "#b45309",
                      bgcolor: "#fef3c7",
                      border: "1px solid #fcd34d",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "#fde68a",
                        borderColor: "#fbbf24",
                      },
                    }}
                  >
                    ✦ 开通会员
                  </Button>
                )}
              </Box>
              */}
            </>
          ) : (
            <Typography
              variant="h6"
              color="primary"
              onClick={onLoginClick}
              sx={{ cursor: "pointer" }}
            >
              立即登录
            </Typography>
          )}
        </Box>
      </Box>

      {/* 菜单列表 */}
      <List sx={{ bgcolor: "#fff", borderRadius: 2, boxShadow: 1 }}>
        {/* QQ交流群 */}
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleCopy(CONTACT_INFO.qqGroup, "QQ群号")}
          >
            <ListItemIcon>
              <ChatIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="QQ交流群" secondary={CONTACT_INFO.qqGroup} />
          </ListItemButton>
        </ListItem>

        <Divider component="li" />

        {/* 作者微信已移除（联系方式仅保留QQ群和邮箱），原代码保留：
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleCopy(CONTACT_INFO.wechat, "微信号")}
          >
            <ListItemIcon>
              <WechatIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="作者微信" secondary={CONTACT_INFO.wechat} />
          </ListItemButton>
        </ListItem>

        <Divider component="li" />
        */}

        {/* 作者邮箱 */}
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleCopy(CONTACT_INFO.email, "邮箱")}
          >
            <ListItemIcon>
              <EmailIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="作者邮箱" secondary={CONTACT_INFO.email} />
          </ListItemButton>
        </ListItem>

        {user && (
          <>
            <Divider component="li" />
            <ListItem disablePadding>
              <ListItemButton onClick={onLogout}>
                <ListItemIcon>
                  <LogoutIcon color="error" />
                </ListItemIcon>
                <ListItemText primary="退出登录" />
              </ListItemButton>
            </ListItem>
          </>
        )}
      </List>

      {/* 复制成功提示 */}
      <Snackbar
        open={copyTip.open}
        autoHideDuration={2000}
        onClose={() => setCopyTip({ ...copyTip, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
          onClose={() => setCopyTip({ ...copyTip, open: false })}
        >
          {copyTip.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
